import { OperationStatus } from '../models';

const REQUEST_ID_PREFIX = 'request-';

export function generateRequestId(): string {
  return `${REQUEST_ID_PREFIX}${Date.now()}`;
}

export function isPendingRequest(lastRequestStatus: OperationStatus | null): boolean {
  return lastRequestStatus?.status === 'pending';
}
